import React from 'react';

import Select from 'react-select';

import rectifiedStatus from '@/data/rectifiedStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectRectifiedStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={rectifiedStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={rectifiedStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectRectifiedStatus;
